import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { useProvider } from './MenuProvider'

const PrivateRoute = ({ children }) => {
  const { 
    buscarDadosPorId,
    auth,
  } = useProvider();
  const [loading, setLoading] = useState(true);
  const [logado, setLogado] = useState(false);

  useEffect(()=>{
      let cancelado = false;
      const carregarLocal = async()=>{
        try{
          const response = await buscarDadosPorId('local_registros', "auth");
          if (!cancelado) {
              if(response){
                setLogado(true);
              }else{
                setLogado(false);
              }
          }
        }catch(err){
          console.error(err);
        }finally{
          if (!cancelado) setLoading(false);
        }
      }
      carregarLocal();
      return () => { cancelado = true; };
  },[auth, buscarDadosPorId])
  
  if (loading) {
    return <p className="text-center"><Spinner animation="border"/></p>;
  }
  if (!logado) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default PrivateRoute;
